import styled, { css } from 'styled-components';
import noop from 'lodash/noop';

import { Arrow } from 'shared/icons/Arrow';

interface IArrowButtonProps {
  className?: string;
  direction: 'right' | 'left';
  onArrowClick?: (direction: string) => void;
  style?: { [key: string]: string };
  show?: boolean;
  showOnHover?: boolean;
}

export const ArrowButton = ({
  className,
  direction,
  onArrowClick = noop,
  style,
  show,
  showOnHover,
}: IArrowButtonProps) => {
  const handleClick = () => {
    onArrowClick(direction);
  };
  return (
    <ArrowButton.Button
      data-qa="arrow_button"
      className={className}
      onClick={handleClick}
      style={style}
      $direction={direction}
      $show={show}
      $showOnHover={showOnHover}
    >
      <Arrow direction={direction} />
    </ArrowButton.Button>
  );
};

const rightArrow = css`
  right: 0;
`;

const leftArrow = css`
  left: 0;
`;

const opacityTransition = css`
  opacity: 1;
  -webkit-transition: opacity 0.25s ease-in-out 0s;
  transition: opacity 0.25s ease-in-out 0s;
`;

const hoverOpacityTransition = css`
  :hover {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease-in-out 0s;
    transition: opacity 0.25s ease-in-out 0s;
  }
`;

ArrowButton.Button = styled.button<{
  $direction: IArrowButtonProps['direction'];
  $show: boolean;
  $showOnHover: boolean;
}>`
  height: calc(100vh - 182px);
  cursor: pointer;
  opacity: 0;
  z-index: ${({ theme }) => theme.zIndex.arrowButton};
  ${({ $direction }) => ($direction === 'right' ? rightArrow : leftArrow)};
  ${({ $show }) => $show && opacityTransition};
  ${({ $showOnHover }) => $showOnHover && hoverOpacityTransition};
`;
